module.exports = __webpack_public_path__ + "img/ico-expand-white.4b27c12b.svg";